import React, { useContext } from "react";
import { Link } from "react-router-dom";
import GlobalContext from "../../context/GlobalContext";
import useLogin from "../../services/useLogin";
import { Menu, MenuButton, MenuItem, MenuItems } from "@headlessui/react";
import { ChevronDown } from "lucide-react";

function Navbar() {
  const { userInfo } = useContext(GlobalContext);
  const { Logout } = useLogin();

  return (
    <header className="w-full backdrop-blur-sm sticky top-0 z-50">
      <div className="px-4 sm:px-6 md:px-8">
        <div className="max-w-7xl mx-auto flex items-center justify-between py-4">
          {/* Logo (optional) */}
          <Link
            to="/"
            className="flex items-center gap-3 font-bold text-2xl text-slate-800"
          >
            <div className="bg-green-100 p-2 rounded-xl">
              <img
                src="/assets/logo/logo.svg"
                alt="MedTag Logo"
                className="h-6 w-6"
              />
            </div>
            MedTag
          </Link>

          {/* Profile Menu */}
          {userInfo && (
            <Menu as="div" className="relative inline-block text-left">
              <MenuButton className="flex items-center gap-2 px-2 py-1 rounded-md">
                <div className="w-8 h-8 bg-green-100 rounded-full flex items-center justify-center">
                  <span className="text-green-700 font-semibold text-sm">
                    {userInfo.first_name?.charAt(0)}
                  </span>
                </div>
                <span className="font-semibold text-slate-700 hidden sm:block">
                  {userInfo.first_name}
                </span>
                <ChevronDown className="w-4 h-4 text-gray-400" />
              </MenuButton>

              <MenuItems className="absolute right-0 mt-2 w-48 origin-top-right bg-white border border-gray-200 rounded-md shadow-lg focus:outline-none z-50">
                <div className="py-1">
                  <MenuItem>
                    {({ active }) => (
                      <Link
                        to="/edit-profile"
                        className={`block px-4 py-2 text-sm ${
                          active ? "bg-gray-100 text-gray-900" : "text-gray-700"
                        }`}
                      >
                        Settings
                      </Link>
                    )}
                  </MenuItem>

                  <MenuItem>
                    {({ active }) => (
                      <Link
                        to="/membership"
                        className={`block px-4 py-2 text-sm ${
                          active ? "bg-gray-100 text-gray-900" : "text-gray-700"
                        }`}
                      >
                        Billing & Plans
                      </Link>
                    )}
                  </MenuItem>

                  <MenuItem>
                    {({ active }) => (
                      <Link
                        to="/contact"
                        className={`block px-4 py-2 text-sm ${
                          active ? "bg-gray-100 text-gray-900" : "text-gray-700"
                        }`}
                      >
                        Contact Support
                      </Link>
                    )}
                  </MenuItem>

                  <MenuItem>
                    {({ active }) => (
                      <button
                        onClick={Logout}
                        className={`block w-full text-left px-4 py-2 text-sm ${
                          active ? "bg-gray-100 text-gray-900" : "text-gray-700"
                        }`}
                      >
                        Sign out
                      </button>
                    )}
                  </MenuItem>
                </div>
              </MenuItems>
            </Menu>
          )}
        </div>
      </div>
    </header>
  );
}

export default Navbar;
